// クレジットカード・プラン・決済まわりの文言
// クレジットカード
export const CC_REGISTER_FAILED = 'クレジットカードの登録に失敗しました';
export const CC_REGISTER_PROMPT = 'まだクレジットカードが登録されていません';
export const CC_CHANGE_SUCCEEDED = 'クレジットカードを変更しました';
export const CC_CHANGE_FAILED = 'クレジットカードの変更に失敗しました';
export const CC_3DS_SUCCEEDED = '本人認証サービスの認証が完了しました';
export const CC_3DS_FAILED = '本人認証サービスの認証に失敗しました';
export const CC_NUMBER_EMPTY = 'カード番号を入力してください';
export const CC_EXP_MONTH_EMPTY = '有効期限(月)を入力してください';
export const CC_EXP_YEAR_EMPTY = '有効期限(年)を入力してください';
export const CC_CVC_EMPTY = 'セキュリティコードを入力してください';
export const POLICY_NOT_CHECKED = '利用規約に同意してください';
// コーチング決済
export const COACHING_PLAN_PAYMENT_FAILED = '現在、フィットライフコーチの新規受付は終了しています。すでにご利用中の方は、引き続きご利用いただけます。';
export const COACHING_PLAN_PAYMENT_FAILED_BECAUSE_USER_QUIT = '退会手続き済みのためフィットライフコーチサービスを開始することができません。';
export const UNSUBSCRIBE_COACHING_PLAN_FAILED = 'コーチングプランの停止に失敗しました';
// プラン
export const PLAN_INDEX_FAILED = 'プラン一覧取得に失敗しました';
export const CAMPAIGN_CODE_CHECK_FAILED = 'クーポンコードの判定処理に失敗しました';
export const CAMPAIGN_CODE_NOT_FOUND = 'クーポンコードが不正です';
export const PLAN_RESET_SUCCEEDED = 'プラン変更を取り消しました';
export const PLAN_RESET_FAILED = 'プラン変更の取り消しに失敗しました';
export const PLAN_UNSELECTED = 'プランを選択してください';
export const PLAN_UNREGISTERED = 'プランがまだ登録されてないので選択してください';
export const NO_PAYMENT_CARD_REGISTRATION_PLAN_FAILED = '認証コードが無効か、登録用プランを取得できませんでした。URLをご確認のうえ再度お試しください。';
export const PLAN_NOT_SUPPORTED_FOR_COLLABORATION_CODE = 'このプランは認証コードからの登録に対応していません';
